/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x4f6b=['Template','enableCommand','insertTemplate','has','plugins','afterInit'];(function(_0x1d1424,_0x4f6b5f){const _0x2542c2=function(_0x2bf09c){while(--_0x2bf09c){_0x1d1424['push'](_0x1d1424['shift']());}};_0x2542c2(++_0x4f6b5f);}(_0x4f6b,0xde));const _0x2542=function(_0x1d1424,_0x4f6b5f){_0x1d1424=_0x1d1424-0x0;let _0x2542c2=_0x4f6b[_0x1d1424];return _0x2542c2;};import{Plugin as _0xf9c846}from'ckeditor5/src/core';export default class yt extends _0xf9c846{[_0x2542('0x5')](){const _0x283be9=this['editor'];_0x283be9['plugins'][_0x2542('0x3')](_0x2542('0x0'))&&_0x283be9[_0x2542('0x4')]['get']('TrackChangesEditing')[_0x2542('0x1')](_0x2542('0x2'));}}